import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import Curriculum from '../Curriculum';
import CampusIndex from './routes/CampusIndex';

const CampusesLazy = React.lazy(
	() => import(/* webpackChunkName : 'Campuses' */ './components')
);

export default (store) => {
	return {
		path: '/:campusId',
		element: <AsyncLoading component={<CampusesLazy />} />,
		children: [CampusIndex(), Curriculum(store)],
	};
};
